<template>
  <transition name="fade" v-if="config.show">
    <div class="modal-box">
      <div class="modal modal-lg p-0">
        <div class="modal-header clearfix">
          <h2 class="pull-left">신청상세</h2>
          <a class="close" @click="$emit('close')">×</a>
        </div>
        <div class="modal-body p-0 clearfix">
          <!-- LEFT INFO -->
          <div class="box left">
            <h1 class="title">교육 신청</h1>
            <p class="menu-nav">{{config.appl_info.lec.category}}</p>
            <p class="subject-tit">{{config.appl_info.lec.lecName}}</p>
            <ul>
              <li>
                <b>교육 대상 :</b>
                <div v-html="config.appl_info.lec.lesTargetType"></div>
                <div v-html="config.appl_info.lec.lesTargetDetail"></div>
              </li>
              <li>
                <b>신청 안내:</b>
                <div v-html="config.appl_info.lec.applGuide"></div>
              </li>
              <li>
                <b>교육 안내 :</b>
                <div v-html="config.appl_info.lec.eduGuide"></div>
              </li>
              <li>
                <b>
                  - ( <img src="images/check2.png" alt="중요" /> )는 필수 입력 사항입니다.
                </b>
              </li>
            </ul>
          </div>

          <!-- 신청양식: 직장맘 프로그램 서북권 온라인 공통 -->
          <div class="box right" v-if="config.appl_info.lec.applForm=='공통'">

            <p class="form-tit m-0">신청인</p>
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 이름
              </span>
              <input class="form-control" type="text" :value="config.appl_info.mber.mberName" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 전화번호
              </span>
              <input
                class="form-control"
                type="text"
                placeholder="'-'없이 번호 입력"
                :value="config.appl_info.mber.mobileNum"
              />
            </div>

            <div class="input-group full-width round m-b-30">
              <span class="input-group-addon label bg-blue v-mid text-white">
                소속
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('소속')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                아이돌봄 프로그램 신청
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('아이돌봄 프로그램 신청')">
                <option value="">선택</option>
                <option value="유">유</option>
                <option value="무">무</option>
              </select>
            </div>
            
            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                자녀 이름
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('자녀 이름')" />
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                자녀 나이(출생년도)
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('자녀 나이')" />
            </div>

            <div class="input-group full-width round m-b-30">
              <span class="input-group-addon label bg-blue v-mid text-white">
                자녀 성별
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('자녀 성별')" >
                <option value="">선택</option>
                <option value="남">남</option>
                <option value="여">여</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                프로그램을 어디서 알게 되었나요?
              </span>
              <div class="m-l-5">
                <div>
                  <input id="chk001" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램을 어디서 알게 되었나요?') === '직장맘지원센터 홈페이지(또는 블로그, 페이스북 등)'" />
                  <label for="chk001">직장맘지원센터 홈페이지(또는 블로그, 페이스북 등)</label>
                </div>
                <div>
                  <input id="chk002" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램을 어디서 알게 되었나요?') === '유관기관(서울혁신센터, 여성능력개발원 등)SNS'" />
                  <label for="chk002">유관기관(서울혁신센터, 여성능력개발원 등)SNS</label>
                </div>
                <div>
                  <input id="chk003" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램을 어디서 알게 되었나요?') === '지인소개'" />
                  <label for="chk003">지인소개</label>
                </div>
                <div>
                  <input id="chk004"  class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램을 어디서 알게 되었나요?') === '문자안내'" />
                  <label for="chk004">문자안내</label>
                </div>
                <div>
                  <input id="chk005" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램을 어디서 알게 되었나요?') === '기타'" />
                  <label for="chk005">기타</label>
                  <input class="form-control" type="text" :value="config.appl_info | value('프로그램을 어디서 알게 되었나요?-기타내용')" />
                </div>
              </div>
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                기존에 프로그램을 수강해 본 적 있으신가요?
              </span>
              <textarea class="form-control" type="text" :value="config.appl_info | value('기존에 프로그램을 수강해 본 적 있으신가요?')" />
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                프로그램을 신청하신 이유는 무엇인가요?
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('프로그램을 신청하신 이유는 무엇인가요?')" />
            </div>

            <!-- <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                비밀번호
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('password')" disabled/>
            </div> -->

            <div class="input-group full-width round m-b-5">
              <div class="m-l-5">
                <input id="mobileRecvEnable" class="checkbox2" type="checkbox" :checked="config.appl_info.mobileRecvEnable"/>
                <label for="mobileRecvEnable" class="v-mid full-width m-0">안내문자 신청합니다.</label>
              </div>
            </div>

            <div class="input-group full-width round m-b-5">
              <div class="m-l-5">
                <input id="agreement" class="checkbox2" type="checkbox" :checked="config.appl_info | value('개인정보 수집과 이용 동의')" disabled/>
                <label for="agreement" class="v-mid full-width m-0">개인정보 수집과 이용 동의</label>
              </div>
            </div>

            <!-- <button class="btn bg-deepblue text-white full-width round m-t-30">신청서 수정</button> -->
          </div>

          <!-- 신청양식: 직장맘 프로그램 서북권 온라인 런치노동법 -->
          <div class="box right" v-if="config.appl_info.lec.applForm=='런치노동법'">

            <p class="form-tit m-0">신청인</p>
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 이름
              </span>
              <input class="form-control" type="text" :value="config.appl_info.mber.mberName" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 전화번호
              </span>
              <input
                class="form-control"
                type="text"
                placeholder="'-'없이 번호 입력"
                :value="config.appl_info.mber.mobileNum"
              />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 이메일
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('이메일')" />
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                소속
              </span>
              <div class="m-l-5">
                <div>
                  <input id="chk001" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '소속') === '공무원 또는 공공기관/공기업 또는 상시'" />
                  <label for="chk001">공무원 또는 공공기관/공기업 또는 상시</label>
                </div>
                <div>
                  <input id="chk002" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '소속') === '근로자 수 300인 이상'" />
                  <label for="chk002">근로자 수 300인 이상</label>
                </div>
                <div>
                  <input id="chk003" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '소속') === '민간위탁기관'" />
                  <label for="chk003">민간위탁기관</label>
                </div>
                <div>
                  <input id="chk004"  class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '소속') === '사기업(5인이상)'" />
                  <label for="chk004">사기업(5인이상)</label>
                </div>
                <div>
                  <input id="chk005"  class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '소속') === '사기업(5인미만)'" />
                  <label for="chk005">사기업(5인미만)</label>
                </div>
                <div>
                  <input id="chk006"  class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '소속') === '자영업자'" />
                  <label for="chk006">자영업자</label>
                </div>
                <div>
                  <input id="chk007" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '소속') === '기타'" />
                  <label for="chk007">기타</label>
                  <input class="form-control" type="text" :value="config.appl_info | value('소속-기타내용')" />
                </div>
              </div>
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                어디서 런치노동법을 알게 되었나요?
              </span>
              <div class="m-l-5">
                <div>
                  <input id="chk001" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '어디서 런치노동법을 알게 되었나요?') === '서북권직장맘지원센터 홈페이지'" />
                  <label for="chk001">서북권직장맘지원센터 홈페이지</label>
                </div>
                <div>
                  <input id="chk002" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '어디서 런치노동법을 알게 되었나요?') === '서북권직장맘지원센터 네이버 블로그'" />
                  <label for="chk002">서북권직장맘지원센터 네이버 블로그</label>
                </div>
                <div>
                  <input id="chk003" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '어디서 런치노동법을 알게 되었나요?') === '지인의 소개'" />
                  <label for="chk003">지인의 소개</label>
                </div>
                <div>
                  <input id="chk004"  class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '어디서 런치노동법을 알게 되었나요?') === '문자 안내'" />
                  <label for="chk004">문자 안내</label>
                </div>
                <div>
                  <input id="chk005"  class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '어디서 런치노동법을 알게 되었나요?') === '유관기관 SNS(서울혁신파크, 육아종합지원센터 등)'" />
                  <label for="chk005">유관기관 SNS(서울혁신파크, 육아종합지원센터 등)</label>
                </div>
                <div>
                  <input id="chk006"  class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '어디서 런치노동법을 알게 되었나요?') === 'E-Mail'" />
                  <label for="chk006">E-Mail</label>
                </div>
                <div>
                  <input id="chk007" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '어디서 런치노동법을 알게 되었나요?') === '기타'" />
                  <label for="chk007">기타</label>
                  <input class="form-control" type="text" :value="config.appl_info | value('어디서 런치노동법을 알게 되었나요?-기타내용')" />
                </div>
              </div>
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                식사 준비할 때 참고할 사항이 있나요?(채식, 알레르기 등)
              </span>
              <textarea class="form-control" type="text" :value="config.appl_info | value('식사 준비할 때 참고할 사항이 있나요?(채식, 알레르기 등)')" />
            </div>

            <!-- <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                비밀번호
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('password')" disabled/>
            </div> -->

            <div class="input-group full-width round m-b-5">
              <div class="m-l-5">
                <input id="mobileRecvEnable" class="checkbox2" type="checkbox" :checked="config.appl_info.mobileRecvEnable"/>
                <label for="mobileRecvEnable" class="v-mid full-width m-0">안내문자 신청합니다.</label>
              </div>
            </div>

            <div class="input-group full-width round m-b-5">
              <div class="m-l-5">
                <input id="agreement" class="checkbox2" type="checkbox" :checked="config.appl_info | value('개인정보 수집과 이용 동의')" disabled/>
                <label for="agreement" class="v-mid full-width m-0">개인정보 수집과 이용 동의</label>
              </div>
            </div>

            <!-- <button class="btn bg-deepblue text-white full-width round m-t-30">신청서 수정</button> -->
          </div>

          <!-- 신청양식: 직장맘 프로그램 동부권 온라인 법률교육 -->
          <div class="box right" v-if="config.appl_info.lec.applForm=='법률교육'">

            <p class="form-tit m-0">신청자 정보</p>
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                사업장명
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('사업장명')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 이름
              </span>
              <input class="form-control" type="text" :value="config.appl_info.mber.mberName" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 전화번호
              </span>
              <input
                class="form-control"
                type="text"
                placeholder="'-'없이 번호 입력"
                :value="config.appl_info.mber.mobileNum"
              />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                이메일
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('이메일')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                근로자수
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('근로자수')">
                <option
                  v-for="(v,idx) in new Array(999)"
                  :key="idx"
                  :value="idx+1"
                >{{idx+1}}</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                여성근로자수
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('여성근로자수')">
                <option value=''>선택</option>
                <option
                  v-for="(v,idx) in new Array(999)"
                  :key="idx"
                  :value="idx+1"
                >{{idx+1}}</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                취업규칙
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('취업규칙')">
                <option value=''>선택</option>
                <option value='있음'>있음</option>
                <option value='없음'>없음</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                근로계약서
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('근로계약서')">
                <option>선택</option>
                <option value="작성">작성</option>
                <option value="미작성">미작성</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                종사업종
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('종사업종')">
                <option value="">선택</option>
                <option value="제조업">제조업</option>
                <option value="건설업">건설업</option>
                <option value="도매 및 소매">도매 및 소매</option>
                <option value="숙박 및 음식점업">숙박 및 음식점업</option>
                <option value="출판·영상·정보서비스">출판·영상·정보서비스</option>
                <option value="금융·보험">금융·보험</option>
                <option value="공공기관">공공기관</option>
                <option value="사업지원·사무서비스">사업지원·사무서비스</option>
                <option value="교육서비스(어린이집 등)">교육서비스(어린이집 등)</option>
                <option value="보건 및 사회복지">보건 및 사회복지</option>
                <option value="유통·무역">유통·무역</option>
                <option value="일반서비스">일반서비스</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                소재지
              </span>
                <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('소재지')">
                  <option value="">선택</option>
                  <option value="강남구">강남구</option>
                  <option value="강동구">강동구</option>
                  <option value="강북구">강북구</option>
                  <option value="강서구">강서구</option>
                  <option value="관악구">관악구</option>
                  <option value="광진구">광진구</option>
                  <option value="구로구">구로구</option>
                  <option value="금천구">금천구</option>
                  <option value="노원구">노원구</option>
                  <option value="도봉구">도봉구</option>
                  <option value="동대문구">동대문구</option>
                  <option value="동작구">동작구</option>
                  <option value="마포구">마포구</option>
                  <option value="서대문구">서대문구</option>
                  <option value="서초구">서초구</option>
                  <option value="성동구">성동구</option>
                  <option value="성북구">성북구</option>
                  <option value="송파구">송파구</option>
                  <option value="양천구">양천구</option>
                  <option value="영등포구">영등포구</option>
                  <option value="용산구">용산구</option>
                  <option value="은평구">은평구</option>
                  <option value="종로구">종로구</option>
                  <option value="중구">중구</option>
                  <option value="중랑구">중랑구</option>
                </select>
            </div>

            <p class="form-tit m-0">신청 내용</p>
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                교육 희망일
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('교육 희망일')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                교육 희망장소
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('교육 희망장소')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                교육 유형
              </span>
                <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('교육 유형')">
                  <option value="">선택</option>
                  <option value="런치 교육(샌드위치 제공)">런치 교육(샌드위치 제공)</option>
                  <option value="노동법률특강">노동법률특강</option>
                </select>
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                노동법률교육 요청내용
              </span>
              <div class="m-l-5">
                <div>
                  <input id="chk001" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '노동법률교육 요청내용') === '임신·육아기 모성보호제도 및 일·생활 균형 지원제도'" />
                  <label for="chk001">임신·육아기 모성보호제도 및 일·생활 균형 지원제도</label>
                </div>
                <div>
                  <input id="chk002" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '노동법률교육 요청내용') === '근로계약서 읽기(근로계약서 작성, 근로계약기간, 근무장소 및 근무내용, 임금, 근로시간, 휴가, 휴일, 휴게 등)'" />
                  <label for="chk002">근로계약서 읽기(근로계약서 작성, 근로계약기간, 근무장소 및 근무내용, 임금, 근로시간, 휴가, 휴일, 휴게 등))</label>
                </div>
                <div>
                  <input id="chk003"  class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '노동법률교육 요청내용') === '채용에서 퇴직까지 노동관계법(근로기준법, 고용보험법 등) 바로알기'" />
                  <label for="chk003">채용에서 퇴직까지 노동관계법(근로기준법, 고용보험법 등) 바로알기</label>
                </div>
                <div>
                  <input id="chk04" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '노동법률교육 요청내용') === '기타'" />
                  <label for="chk004">기타</label>
                <input class="form-control" type="text" :value="config.appl_info | value('노동법률교육 요청내용-기타내용')" />
                </div>
              </div>
            </div>
            
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                기타 문의사항
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('기타 문의사항')" />
            </div>

            <!-- <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                비밀번호
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('password')" disabled/>
            </div> -->

            <div class="input-group full-width round m-b-5">
              <div class="m-l-5">
                <input id="agreement" class="checkbox2" type="checkbox" :checked="config.appl_info | value('개인정보 수집과 이용 동의')" disabled/>
                <label for="agreement" class="v-mid full-width m-0">개인정보 수집과 이용 동의</label>
              </div>
            </div>

            <!-- <button class="btn bg-deepblue text-white full-width round m-t-30">신청서 수정</button> -->
          </div>

          <!-- 신청양식: 직장맘 프로그램 동부권 온라인 기획강좌 -->
          <div class="box right" v-if="config.appl_info.lec.applForm=='기획강좌'">

            <p class="form-tit m-0">신청자 정보</p>
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                기관명
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('기관명')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                소재지
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('소재지')">
                <option value=''>선택</option>
                <option value='강남구'>강남구</option>
                <option value='강동구'>강동구</option>
                <option value='강북구'>강북구</option>
                <option value='강서구'>강서구</option>
                <option value='관악구'>관악구</option>
                <option value='광진구'>광진구</option>
                <option value='구로구'>구로구</option>
                <option value='금천구'>금천구</option>
                <option value='노원구'>노원구</option>
                <option value='도봉구'>도봉구</option>
                <option value='동대문구'>동대문구</option>
                <option value='동작구'>동작구</option>
                <option value='마포구'>마포구</option>
                <option value='서대문구'>서대문구</option>
                <option value='서초구'>서초구</option>
                <option value='성동구'>성동구</option>
                <option value='성북구'>성북구</option>
                <option value='송파구'>송파구</option>
                <option value='양천구'>양천구</option>
                <option value='영등포구'>영등포구</option>
                <option value='용산구'>용산구</option>
                <option value='은평구'>은평구</option>
                <option value='종로구'>종로구</option>
                <option value='중구'>중구</option>
                <option value='중랑구'>중랑구</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 신청자
              </span>
              <input class="form-control" type="text" :value="config.appl_info.mber.mberName" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 연락처
              </span>
              <input
                class="form-control"
                type="text"
                placeholder="'-'없이 번호 입력"
                :value="config.appl_info.mber.mobileNum"
              />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                참여대상
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('참여대상')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                인원
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('인원')">
                <option value=''>선택</option>
                <option
                  v-for="(v,idx) in new Array(999)"
                  :key="idx"
                  :value="idx+1"
                >{{idx+1}}</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                교육날짜
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('교육날짜')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                교육장소
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('교육장소')" />
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                프로그램 요청내용
              </span>
              <div class="m-l-5">
                <div>
                  <input id="chk001" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램 요청내용') === '1. 성인지 감수성 / 성평등노동인권교육'"/>
                  <label for="chk001" class="v-mid full-width m-0">1. 성인지 감수성 / 성평등노동인권교육</label>
                </div>
                <div>
                  <input id="chk002" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램 요청내용') === '2. 상담사례로 본 노동법 팁(온라인)'" />
                  <label for="chk002" class="v-mid full-width m-0">2. 상담사례로 본 노동법 팁(온라인)</label>
                </div>
                <div>
                  <input id="chk003" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램 요청내용') === '3. 슬기로운 부모생활소통, 공감 등 부모교육'" />
                  <label for="chk003" class="v-mid full-width m-0">3. 슬기로운 부모생활소통, 공감 등 부모교육</label>
                </div>
                <div>
                  <input id="chk004" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램 요청내용') === '4. 직장맘 3고충 이해하기(직장, 가족, 나)에 대한 이해와 공감'" />
                  <label for="chk004" class="v-mid full-width m-0">4. 직장맘 3고충 이해하기(직장, 가족, 나)에 대한 이해와 공감</label>
                </div>
                <div>
                  <input id="chk005" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '프로그램 요청내용') === '5. 직장맘 힐링교실연간 주제에 따른 기획강좌(힐링건강교육, 온라인체험강좌 등)'" />
                  <label for="chk005" class="v-mid full-width m-0">5. 직장맘 힐링교실연간 주제에 따른 기획강좌(힐링건강교육, 온라인체험강좌 등)</label>
                </div>
              </div>

            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                교육참석자 특성
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('교육참석자 특성')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                기타 문의사항
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('기타 문의사항')" />
            </div>

            <!-- <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                비밀번호
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('password')" disabled/>
            </div> -->

            <div class="input-group full-width round m-b-5">
              <div class="m-l-5">
                <input id="agreement" class="checkbox2" type="checkbox" :checked="config.appl_info | value('개인정보 수집과 이용 동의')" disabled/>
                <label for="agreement" class="v-mid full-width m-0">개인정보 수집과 이용 동의</label>
              </div>
            </div>

            <!-- <button class="btn bg-deepblue text-white full-width round m-t-30">신청서 수정</button> -->
          </div>

          <!-- 신청양식: 직장맘 프로그램 동부권 온라인 사업주대상 인식사업 -->
          <div class="box right" v-if="config.appl_info.lec.applForm=='사업주대상 인식사업'">

            <p class="form-tit m-0">참여기관 정보</p>
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                사업장명
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('사업장명')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 신청자
              </span>
              <input class="form-control" type="text" :value="config.appl_info.mber.mberName" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 연락처
              </span>
              <input
                class="form-control"
                type="text"
                placeholder="'-'없이 번호 입력"
                :value="config.appl_info.mber.mobileNum"
              />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                이메일
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('이메일')" />
            </div>

            <div v-for="(info,idx) in getItemValue(config.appl_info, '참석자 명단').split('|')" :key="info+idx">
              <div class="input-group full-width round m-b-10">
                <span class="input-group-addon label bg-blue v-mid text-white">
                  <img class="v-mid m-r-10" src="images/check2.png" alt /> 참석자명{{idx+1}}
                </span>
                <input class="form-control" type="text" :value="info.split('/')[0] || ''" />
              </div>

              <div class="input-group full-width round m-b-10">
                <span class="input-group-addon label bg-blue v-mid text-white">
                  <img class="v-mid m-r-10" src="images/check2.png" alt /> 연락처{{idx+1}}
                </span>
                <input
                  class="form-control"
                  type="text"
                  placeholder="'-'없이 번호 입력"
                  :value="info.split('/')[1] || ''"
                />
              </div>

              <div class="input-group full-width round m-b-10">
                <span class="input-group-addon label bg-blue v-mid text-white">
                  이메일{{idx+1}}
                </span>
                <input class="form-control" type="text" :value="info.split('/')[2] || ''" />
              </div>
            </div>

            <!-- <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 참석자명 추가
              </span>
              <button class="form-control" type="text" :value="config.appl_info | value('전자우편')">추가</button>
            </div>
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                <img class="v-mid m-r-10" src="images/check2.png" alt /> 참석자명 삭제
              </span>
              <button class="form-control" type="text" :value="config.appl_info | value('전자우편')">삭제</button>
            </div> -->

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                근로자수
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('근로자수')">
                <option>선택</option>
                <option
                  v-for="(v,idx) in new Array(999)"
                  :key="idx"
                  :value="idx+1"
                >{{idx+1}}</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                여성근로자수
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('여성근로자수')">
                <option>선택</option>
                <option
                  v-for="(v,idx) in new Array(999)"
                  :key="idx"
                  :value="idx+1"
                >{{idx+1}}</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                정규직
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('정규직')">
                <option>선택</option>
                <option
                  v-for="(v,idx) in new Array(999)"
                  :key="idx"
                  :value="idx+1"
                >{{idx+1}}</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                기간제
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('기간제')">
                <option>선택</option>
                <option
                  v-for="(v,idx) in new Array(999)"
                  :key="idx"
                  :value="idx+1"
                >{{idx+1}}</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                취업규칙
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('취업규칙')">
                <option value="">선택</option>
                <option value="있음">있음</option>
                <option value="없음">없음</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                근로계약서
              </span>
              <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('근로계약서')">
                <option value="">선택</option>
                <option value="작성">작성</option>
                <option value="미작성">미작성</option>
              </select>
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                업종
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('업종')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                소재지
              </span>
                <select class="full-width form-control" style="height: 40px; text-align-last: center;" :value="config.appl_info | value('소재지')">
                  <option value="">선택</option>
                  <option value="강남구">강남구</option>
                  <option value="강동구">강동구</option>
                  <option value="강북구">강북구</option>
                  <option value="강서구">강서구</option>
                  <option value="관악구">관악구</option>
                  <option value="광진구">광진구</option>
                  <option value="구로구">구로구</option>
                  <option value="금천구">금천구</option>
                  <option value="노원구">노원구</option>
                  <option value="도봉구">도봉구</option>
                  <option value="동대문구">동대문구</option>
                  <option value="동작구">동작구</option>
                  <option value="마포구">마포구</option>
                  <option value="서대문구">서대문구</option>
                  <option value="서초구">서초구</option>
                  <option value="성동구">성동구</option>
                  <option value="성북구">성북구</option>
                  <option value="송파구">송파구</option>
                  <option value="양천구">양천구</option>
                  <option value="영등포구">영등포구</option>
                  <option value="용산구">용산구</option>
                  <option value="은평구">은평구</option>
                  <option value="종로구">종로구</option>
                  <option value="중구">중구</option>
                  <option value="중랑구">중랑구</option>
                </select>
            </div>

            <p class="form-tit m-0">신청 내용</p>
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                컨설팅 희망일
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('컨설팅 희망일')" />
            </div>

            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                컨설팅 희망장소
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('컨설팅 희망장소')" />
            </div>

            <div class="input-group full-width round m-b-5">
              <span class="input-group-addon label bg-blue v-mid text-white">
                컨설팅 요청내용
              </span>
              <div class="m-l-5">
                <div>
                  <input id="chk001" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '컨설팅 요청내용') === '모성보호제도 운영 및 관리'" />
                  <label for="chk001">모성보호제도 운영 및 관리</label>
                </div>
                <div>
                  <input id="chk002" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '컨설팅 요청내용') === '사업장 취업규칙 검토'" />
                  <label for="chk002">사업장 취업규칙 검토</label>
                </div>
                <div>
                  <input id="chk003" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '컨설팅 요청내용') === '사업장 근로계약서 및 각종 노사합의서류 검토'" />
                  <label for="chk003">사업장 근로계약서 및 각종 노사합의서류 검토</label>
                </div>
                <div>
                  <input id="chk004" class="checkbox2" type="checkbox" :checked="getItemValue(config.appl_info, '컨설팅 요청내용') === '기타'" />
                  <label for="chk004">기타</label>
                  <input class="form-control" type="text" :value="config.appl_info | value('컨설팅 요청내용-기타')" />
                </div>
              </div>
            </div>
            
            <div class="input-group full-width round m-b-10">
              <span class="input-group-addon label bg-blue v-mid text-white">
                기타 문의사항
              </span>
              <input class="form-control" type="text" :value="config.appl_info | value('기타 문의사항')" />
            </div>

            <div class="input-group full-width round m-b-5">
              <div class="m-l-5">
                <input id="agreement" class="checkbox2" type="checkbox" :checked="config.appl_info | value('개인정보 수집과 이용 동의')" disabled/>
                <label for="agreement" class="v-mid full-width m-0">개인정보 수집과 이용 동의</label>
              </div>
            </div>
            <!-- <button class="btn bg-deepblue text-white full-width round m-t-30">신청서 수정</button> -->
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import server from "../statics/server.js";

export default {
  name: "ModalApplyDetail",

  mounted: function() {
    if (this.config.appl_info && this.config.appl_info.lec)
      if (this.config.appl_info.lec.eduPeriodType == "일정 선택")
        this.drawCalendar();
    // 공통코드
    axios
      .post(server.addr() + server.api.COMMON_CODE, { codeId: "FIL001" })
      .then(response => {
        response.data.list.forEach(e => {
          this.$set(this.codes, e.code, e.codeNm);
        });
      });
  },

  default: function() {
    return {
      name: this.name,
      show: false,
      appl_info: null
    };
  },

  data: function() {
    return {
      calendar: null, // 달력객체
      currentYearMonth: "", // 지금 보고있는 년-월
      currentYear: "", // 지금 보고있는 년
      currentMonth: "", // 지금 보고있는 월
      codes: {}
    };
  },

  props: {
    config: Object
  },

  filters: {
    value(appl, name) {
      const e = appl.applInfoList.find(e => e.itemName == name);
      if (e) return e.itemValue;
      return "";
    },
    value_not(appl, name) {
      let e = appl.applInfoList.find(e => e.itemName == name);
      if (e) return !e.itemValue;
      return "";
    },
    code(value, codes) {
      if (codes[value]) return codes[value];
      else value;
    }
  },

  methods: {
    getItemValue(appl, name) {
      const e = appl.applInfoList.find(e => e.itemName == name);
      if (e) return e.itemValue;
      return "";
    },
    prevMonth: function() {
      if (!this.currentYearMonth) return;
      let year = parseInt(this.currentYearMonth.toString().substr(0, 4));
      let month = parseInt(this.currentYearMonth.toString().substr(4, 2));
      month -= 1;
      if (month == 0) {
        year -= 1;
        month = 12;
      }
      let key = year.toString() + ("0" + month).slice(-2);
      if (this.calendar[key]) {
        this.currentYearMonth = key;
        this.currentYear = parseInt(
          this.currentYearMonth.toString().substr(0, 4)
        );
        this.currentMonth = parseInt(
          this.currentYearMonth.toString().substr(4, 2)
        );
      }
      return;
    },
    nextMonth: function() {
      if (!this.currentYearMonth) return;
      let year = parseInt(this.currentYearMonth.toString().substr(0, 4));
      let month = parseInt(this.currentYearMonth.toString().substr(4, 2));
      month += 1;
      if (month == 13) {
        year += 1;
        month = 1;
      }
      let key = year.toString() + ("0" + month).slice(-2);
      if (this.calendar[key]) {
        this.currentYearMonth = key;
        this.currentYear = parseInt(
          this.currentYearMonth.toString().substr(0, 4)
        );
        this.currentMonth = parseInt(
          this.currentYearMonth.toString().substr(4, 2)
        );
      }
      return;
    },
    drawCalendar: function() {
      let start_time = 0,
        start_year_month = 0,
        start_date_year = 0,
        start_date_month = 0,
        start_date_date = 0,
        end_time = 0,
        end_year_month = 0,
        end_date_year = 0,
        end_date_month = 0,
        end_date_date = 0;
      // 달력객체를 비운다.
      this.calendar = {};
      // 시작일과 종료일이 모두 있어야 달력그리기 가능
      if (
        this.config.appl_info.lec.lecEduDateList.length &&
        this.config.appl_info.lec.lecEduDateList[0].eduStartDate &&
        this.config.appl_info.lec.lecEduDateList[
          this.config.appl_info.lec.lecEduDateList.length - 1
        ].eduStartDate
      ) {
        // 시작일 준비
        start_date_year = parseInt(
          this.config.appl_info.lec.lecEduDateList[0].eduStartDate.split("-")[0]
        );
        start_date_month = parseInt(
          this.config.appl_info.lec.lecEduDateList[0].eduStartDate.split("-")[1]
        );
        start_date_date = parseInt(
          this.config.appl_info.lec.lecEduDateList[0].eduStartDate.split("-")[2]
        );
        start_year_month = parseInt(
          this.config.appl_info.lec.lecEduDateList[0].eduStartDate.split(
            "-"
          )[0] +
            this.config.appl_info.lec.lecEduDateList[0].eduStartDate.split(
              "-"
            )[1]
        );
        start_time = new Date(
          start_date_year,
          start_date_month - 1,
          start_date_date,
          0,
          0,
          0
        ).getTime();
        // 종료일 준비
        end_date_year = parseInt(
          this.config.appl_info.lec.lecEduDateList[
            this.config.appl_info.lec.lecEduDateList.length - 1
          ].eduStartDate.split("-")[0]
        );
        end_date_month = parseInt(
          this.config.appl_info.lec.lecEduDateList[
            this.config.appl_info.lec.lecEduDateList.length - 1
          ].eduStartDate.split("-")[1]
        );
        end_date_date = parseInt(
          this.config.appl_info.lec.lecEduDateList[
            this.config.appl_info.lec.lecEduDateList.length - 1
          ].eduStartDate.split("-")[2]
        );
        end_year_month = parseInt(
          this.config.appl_info.lec.lecEduDateList[
            this.config.appl_info.lec.lecEduDateList.length - 1
          ].eduStartDate.split("-")[0] +
            this.config.appl_info.lec.lecEduDateList[
              this.config.appl_info.lec.lecEduDateList.length - 1
            ].eduStartDate.split("-")[1]
        );
        end_time = new Date(
          end_date_year,
          end_date_month - 1,
          end_date_date,
          23,
          59,
          59
        ).getTime();
      } else return;
      // 시작일이 속한 년-월부터 종료일이 속한 년-월까지 순회하면서 한달 단위로 달력객체를 만든다.
      for (let time = start_time; time <= end_time; ) {
        // 지금 그리고 있는 달의 년-월을 만든다.
        let this_date = new Date(time);
        let this_year = this_date.getFullYear().toString();
        let this_month = ("0" + (this_date.getMonth() + 1)).slice(-2);
        let this_year_month = parseInt(this_year + this_month);
        this.$set(this.calendar, this_year_month, []);
        // 지금 그리고 있는 달의 1일의 요일과 마지막 날짜와 마지막 날짜의 요일을 구한다.
        let this_first_day = new Date(
          this_year,
          parseInt(this_month) - 1,
          1,
          0,
          0,
          0
        ).getDay();
        let this_last_date = new Date(
          this_year,
          parseInt(this_month),
          0
        ).getDate();
        //let this_last_day = (new Date(this_year, parseInt(this_month), 0)).getDay();
        // 지금 그리고 있는 달 안에서, 1주일 단위로 순회하면서
        let week = 0,
          date = 1;
        for (;;) {
          // 지금 그리고 있는 달의 지금 그리고 있는 주를 준비한다.
          this.calendar[this_year_month].push([]);
          // 지금 그리고 있는 주가 첫째주라면, 1일의 요일까지 날짜를 넘긴다.
          if (week == 0)
            for (let skip = 0; skip < this_first_day; skip += 1)
              this.calendar[this_year_month][week].push(null);
          // 지금 그리고 있는 달이 시작일이 속한 달이면, 1일부터 시작일까지 날짜를 넘긴다.
          if (this_year_month == start_year_month) {
            while (
              this.calendar[this_year_month][week].length < 7 &&
              date < start_date_date
            ) {
              this.calendar[this_year_month][week].push(null);
              date += 1;
            }
            // 시작일까지 넘기다가 주가 꽉 차서 더 이상 못넘기는 경우, 다음주로 이행해서 계속한다.
            if (this.calendar[this_year_month][week].length == 7) {
              week += 1;
              continue;
            }
          }
          // 지금 그리고 있는 달이 종료일이 속한 달이 아니면, 현재날짜부터 말일까지 순회하면서 날짜를 그린다.
          if (this_year_month < end_year_month) {
            while (
              this.calendar[this_year_month][week].length < 7 &&
              date <= this_last_date
            ) {
              this.calendar[this_year_month][week].push({
                date,
                yearMonth: this_year_month,
                selected: this.config.appl_info.applEduDateList.find(
                  e =>
                    e.eduStartDate ==
                    this_year +
                      "-" +
                      ("0" + this_month).slice(-2) +
                      "-" +
                      ("0" + date).slice(-2)
                )
                  ? true
                  : false
              });
              date += 1;
            }
            // 말일까지 날짜가 아직 안됐는데 주가 꽉 차서 더 이상 못넘기는 경우, 다음주로 이행해서 계속한다.
            if (
              this.calendar[this_year_month][week].length == 7 &&
              date < this_last_date
            ) {
              week += 1;
              continue;
            }
          }
          // 지금 그리고 있는 달이 종료일이 속한 달이면, 현재날짜부터 종료일까지 순회하면서 날짜를 그린다.
          if (this_year_month == end_year_month) {
            while (
              this.calendar[this_year_month][week].length < 7 &&
              date <= end_date_date
            ) {
              this.calendar[this_year_month][week].push({
                date,
                yearMonth: this_year_month,
                selected: this.config.appl_info.applEduDateList.find(
                  e =>
                    e.eduStartDate ==
                    this_year +
                      "-" +
                      ("0" + this_month).slice(-2) +
                      "-" +
                      ("0" + date).slice(-2)
                )
                  ? true
                  : false
              });
              date += 1;
            }
            // 종료일까지 날짜가 아직 안됐는데 주가 꽉 차서 더 이상 못넘기는 경우, 다음주로 이행해서 계속한다.
            if (
              this.calendar[this_year_month][week].length == 7 &&
              date < end_date_date
            ) {
              week += 1;
              continue;
            }
          }
          // 지금 그리고 있는 달이 종료일이 속한 달이 아니고 지금 그리고 있는 주에 지금 그리고 있는 달의 말일이 포함되어 있으면,
          // 말일 이후 토요일까지 남은 날짜를 넘기고 이 달을 마무리한다.
          if (
            this_year_month < end_year_month &&
            this.calendar[this_year_month][week].find(
              d => d && d.date == this_last_date
            )
          ) {
            while (this.calendar[this_year_month][week].length < 7)
              this.calendar[this_year_month][week].push(null);
            break;
          }
          // 지금 그리고 있는 달이 종료일이 속한 달이고 지금 그리고 있는 주에 종료일 포함되어 있으면,
          // 종료일 이후 토요일까지 남은 날짜를 넘기고 종료일이 속한 달의 마지막 주까지 넘긴 뒤 이 달을 마무리한다.
          if (
            this_year_month == end_year_month &&
            this.calendar[this_year_month][week].find(
              d => d && d.date == end_date_date
            )
          ) {
            while (this.calendar[this_year_month][week].length < 7)
              this.calendar[this_year_month][week].push(null);
            // 이 달에 주가 몇개여야 하는지 산출
            let weeks_of_this_month =
              (this_first_day +
                (7 - ((this_last_date + this_first_day) % 7)) +
                this_last_date) /
              7;
            if ((this_last_date + this_first_day) % 7 == 0)
              weeks_of_this_month -= 1;
            while (this.calendar[this_year_month].length < weeks_of_this_month)
              this.calendar[this_year_month].push([
                null,
                null,
                null,
                null,
                null,
                null,
                null
              ]);
            break;
          }
          // 다음주로 이행한다.
          week += 1;
        } // 주간루프
        // 다음달로 이행한다.
        time = new Date(this_date.setMonth(this_date.getMonth() + 1)).getTime();
      } // 월간루프
      // 시작월을 달력에 표시할 첫월로 표시한다.
      this.currentYearMonth = start_year_month;
      this.currentYear = start_date_year;
      this.currentMonth = start_date_month;
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>